import ProductSummaryProvider from './hooks/useProductSummary';

import { ProductSummaryProps } from './@types/ProductSummaryProps';
import Container from './handles/Container';
import ClearLink from './handles/ClearLink';
import Element from './handles/Element';

const ProductSummary = (props: ProductSummaryProps) => (
	<ProductSummaryProvider {...props}>
		<Container>
			<ClearLink>
				<Element>{props.children}</Element>
			</ClearLink>
		</Container>
	</ProductSummaryProvider>
);

export default ProductSummary;
